import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getAllSessions, passworlessUpdate, revokeSession } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const getAllSessionsService = createAsyncThunk(
    'fetchPreAuthFAF', getAllSessions
)

const initialState = {
    loader: false,
    sessionValue:""
}

const allSessionsSlice = createSlice({
    name: 'preAuth',
    initialState,
    reducers: {
        resetGetAllSessions: (state) => {
            state.loader = false
            state.sessionValue = ""
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllSessionsService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(getAllSessionsService.fulfilled, (state, action) => {
                state.loader = false
                if(action.payload.length == 1){
                state.sessionValue = action.payload[0]
                }
            })
            .addCase(getAllSessionsService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetGetAllSessions } = allSessionsSlice.actions

export default allSessionsSlice.reducer

